import React, { useEffect, useState } from 'react'
import Layout from '../../components/Layout'
import PageHeader from '../../components/PageHeader';
import { CameraAltRounded, ClearRounded, DeviceThermostatRounded, QrCodeOutlined, QrCodeScanner } from '@mui/icons-material';
import { Alert, Button, Col, Divider, Form, Input, InputNumber, Modal, QRCode, Radio, Row, Select, Space, Spin, Table, Tabs, Tag, message } from 'antd';
import { QrReader } from 'react-qr-reader';
import QRScanner from '../../components/QRScanner';
import { Content } from 'antd/es/layout/layout';
import useAxios from 'axios-hooks';
import { BASE_URL, formatDate, titleCase } from '../../utils/Common';
import { getAvailableLocations, getItems, getLocations } from '../../api/locationsApi';
import { stockIn, stockOut } from '../../api/inventoryApi';
const { Search } = Input;
const { Option } = Select;

export default function StockIn() {
  const [form] = Form.useForm();
  const [showSearchByQr, setShowSearchByQr] = useState(false);
  const [showStockIn, setShowStockIn] = useState(false);
  const [itemInfo, setItemInfo] = useState({});
  const [step, setStep] = useState(1);
  const [qrCode, setQRCode] = useState("");
  const [availableLocations, setAvailableLocations] = useState([]);
  const [checkingAvailableLocations, setCheckingAvailableLocations] = useState(false);
  const [qrExists, setQrExists] = useState(false);
  const [checkingQr, setCheckingQr] = useState(false);
  const itemName = Form.useWatch('item_name', form);
  const rack = Form.useWatch('rack', form);
  const tempFrom = Form.useWatch('temperature_from', form);
  const tempTo = Form.useWatch('temperature_to', form);
  const tempType = Form.useWatch('temperature_type', form);
  const [messageApi, contextHolder] = message.useMessage();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hasClickedSearch, setHasClickedSearch] = useState(false);

  // const onSearch = (value) => console.log(value);
  const toaster = (type, content) => {
    messageApi.open({ type, content: titleCase(content) });
  };
  const nextStep = () => {
    setStep(()=>step+1);
  }
  const prevStep = () => {
    setStep(()=>step-1);
  }
  const handleCancel = () => {
    setShowStockIn(false);
    setStep(1);
    setQrExists(false);
    setQRCode("");
  };

  const onSearch = () => {
    _getItems({qr_code: qrCode}); 
    setShowSearchByQr(false);
  }

  async function _getItems(values) {
    try{
      setLoading(true);
      const res = await getItems(values);
      setItems(res.data);
    }catch(err){
      console.log(err)
    }
    setLoading(false);
  }

  async function _getAvailableLocations() {
    setCheckingAvailableLocations(true);
    var _tempInfo = {
      temperature_type: tempType, 
      temperature_from: tempFrom, 
      temperature_to: tempType === "in-range" ? tempTo : tempFrom
    }
    setItemInfo({item_name: itemName, ..._tempInfo});
    const res = await getAvailableLocations({
      requester: 1,
      token: 'sample token',
      temperature_type: tempType, 
      temperature_range_from: tempFrom, 
      temperature_range_to: tempType === "in-range" ? tempTo : tempFrom
    });
    console.log(res)
    if (res.data) {
      setAvailableLocations(res.data);
      form.setFieldValue('rack', `${res.data[0].rack_id}-${res.data[0].id}`) // Select first option by default
    } else if (res.error) {
      setAvailableLocations([]);
    }
    setCheckingAvailableLocations(false);
  }

  const onFinish = async (values) => {
    var _values =  {
      qr_code: qrCode,
      rack_id: parseInt(values.rack.split('-')[0]),
      rack_level_id: parseInt(values.rack.split('-')[1]),
      ...itemInfo
    }

    const res = await stockIn(_values);
    if (res.data) {
      toaster('success', res.data.message)
      form.resetFields();
      setStep(1);
      setShowStockIn(false);
      _getItems();
    } else if (res.error) {
      console.log(res.error)
    }
  };

  async function checkIfQrExists(qr_code) {
    setCheckingQr(true);
    const res = await getItems({
      qr_code,
    });
    if (res.data) {
      if (res.data[0].status === "stockin") {
        setQrExists(true);
      } else {
        form.setFieldValue("item_name", res.data[0].description);
        form.setFieldValue("temperature_type", res.data[0].temperature_type);
        form.setFieldValue("temperature_from", res.data[0].temperature_from);
        form.setFieldValue("temperature_to", res.data[0].temperature_to);
      }
    }
    setCheckingQr(false);
  }

  // CREATE STOCK OUT
  async function _stockOut(qr_code) {
    const res = await stockOut(qr_code);
    if (res.data) {
      console.log(res.data);
      toaster('success', res.data.message);
      _getItems();
    } else if (res.error) {
      console.log(res.error.data.messages.error_messages[0])
      toaster('error', res.error.data.messages.error_messages[0])
    }
  }

  useEffect(() => {
    _getItems();
    document.title = "Stock in"
  }, []);

  return (
    <Layout>
      <PageHeader title="Stock in" noButton/>
      {contextHolder}
      
      <Row gutter={20}>
      <Col xs={24} md={12}>
        {/* STOCK IN FORM */}
        <Form initialValues={{temperature_type: "exact"}} name="stock-in-form" form={form} layout='vertical' onFinish={onFinish}>
          { 
            step === 1 && 
            <>
              <QRScanner data={qrCode} setData={setQRCode} /> 
              
              <Space className='mt-5 flex justify-end'>
                {qrCode && <Button danger onClick={()=>{window.location.reload()}}>Clear</Button>}
                <Button disabled={qrCode===""} type='primary' className='bg-green-500' onClick={()=>{checkIfQrExists(qrCode);nextStep();}}>Next</Button>
                {console.log(qrCode)}
              </Space>
            
            </>
          }
          { step === 2 &&
            <>
            { checkingQr ? <Spin className='flex justify-center align-middle h-20 mt-15' /> : 
              <>
                { qrExists ?
                  <>
                    <Alert
                      message="Uh-oh! Duplicate QR Code Detected"
                      description="The QR code you've scanned corresponds to an item already in the inventory. Please try again."
                      type="warning"
                      showIcon
                    />
                  </>
                  :
                  <>
                    <Form.Item name="item_name" label="Item name:">
                      <Input />
                    </Form.Item>
      
                    <p>Temperature requirement:</p>
                    <Space className='mt-2'>
                      <Form.Item name="temperature_type" noStyle>
                        <Select>
                          <Option value="exact">Exactly</Option>
                          <Option value="higher">Higher than</Option>
                          <Option value="lower">Lower than</Option>
                          <Option value="in-range">In range of</Option>
                        </Select>
                      </Form.Item>
                      {
                        tempType === "in-range" ?
                        <>
                          <Form.Item noStyle name="temperature_from">
                            <InputNumber placeholder='Min' />
                          </Form.Item>
                          -
                          <Form.Item noStyle name="temperature_to">
                            <InputNumber placeholder='Max'/>
                          </Form.Item>
                        </>
                        :
                        <Form.Item noStyle name="temperature_from">
                          <InputNumber />
                        </Form.Item>
                      }
                    </Space>
                  </>
                  
                }
                <Space className='mt-5 flex justify-end'>
                  <Button onClick={()=>{setQRCode(()=>""); form.resetFields(); prevStep();}}>Back</Button>
                  <Button disabled={qrExists} type='primary' className='bg-green-500' onClick={()=>{_getAvailableLocations();nextStep();}}>Next</Button>
                </Space>
              </>
            } 
            </>
          }
          {
            step === 3 &&
            <>
              { checkingAvailableLocations ? <Spin className='flex justify-center align-middle h-20 mt-15' /> : 
                <>
                { availableLocations.length > 0 ? 
                  <Form.Item className='mt-5' label="Select available locations:" name="rack">
                    <Radio.Group>
                      <Space direction="vertical">
                      {availableLocations?.map((location, index) => {
                        return (
                          <Radio disabled={location.current_qty === location.maximum_qty} key={location.id} className='p-3 bg-slate-100 rounded-md' value={`${location.rack_id}-${location.id}`}>
                            <p>{titleCase(location.rack_name)}, Level {titleCase(location.level_name)} {(location.current_qty === location.maximum_qty) && <Tag bordered={false}>At full capacity</Tag>}</p>
                            <small>Temperature: {location.temperature} °C</small>
                            
                            {/* {
                              location.temperature_type === "in-range" && <small>Temperature: {location?.temperature_from}°C - {location?.temperature_to}°C</small>
                            }
                            {
                              location.temperature_type === "exact" && <small>Temperature: Exactly {location?.temperature_from}°C</small>
                            }
                            {
                              location.temperature_type === "higher" && <small>Temperature: Higher than {location?.temperature_from}°C</small>
                            }
                            {
                              location.temperature_type === "lower" && <small>Temperature: Lower than {location?.temperature_from}°C</small>
                            } */}
                            
                          </Radio>
                          )
                        })}
                      </Space>
                    </Radio.Group>
                  </Form.Item>
                  :
                  <Alert
                    message="Error: No racks found."
                    description="Recheck the temperature and try again."
                    type="error"
                    showIcon
                  />
                }

                <Space className='mt-5 flex justify-end'>
                <Form.Item>
                  <Button onClick={prevStep}>Back</Button>
                  <Button disabled={availableLocations.length === 0} type='primary' className='bg-green-500 ml-1' htmlType="submit">
                    Submit
                  </Button>
                </Form.Item>
                </Space>
                </>
              }
            </>
          }
        </Form>
      </Col>
      <Col xs={24} md={12}></Col>
      </Row>
    </Layout>
  )
}
